import {
    FETCH_GET_UNIVERSITY_REQUEST,
    FETCH_GET_UNIVERSITY_SUCCESS,
    FETCH_GET_UNIVERSITY_FAILURE,
} from '../../actions/universities/get-university-actions';

const initialState = {
    university: null,
    isLoading: false,
    error: null,
};

const CLEAR_DATA = "CLEAR_DATA";
const GetUniversityReducer = (state = initialState, action: any) => {
    switch (action.type) {
        case FETCH_GET_UNIVERSITY_REQUEST:
            return {
                ...state,
                isLoading: true,
                error: null,
            };
        case FETCH_GET_UNIVERSITY_SUCCESS:
            return {
                ...state,
                isLoading: false,
                university: action.payload,
            };
        case FETCH_GET_UNIVERSITY_FAILURE:
            return {
                ...state,
                isLoading: false,
                error: action.payload,
            };
        case CLEAR_DATA:
            return {
                ...initialState
            };
        default:
            return state;
    }
};

export default GetUniversityReducer;